module.exports = {
  SYSTEM_DATETIME: {
    key: "system_datetime",
    logicalName: "操作日時"
  },
  ENDPOINT_NAME: {
    key: "endpoint_name",
    logicalName: "API名"
  },
  STATUS: {
    key: "status",
    logicalName: "処理結果"
  },
  ERROR_CODE: {
    key: "error_code",
    logicalName: "エラーコード"
  },
  ERROR_MESSAGE: {
    key: "error_message",
    logicalName: "エラーメッセージ"
  },
  TRACE_ID: {
    key: "trace_id",
    logicalName: "調査用ID"
  }
};
